import { render } from "./PendingOrderModal.vue?vue&type=template&id=56d4b11e"
import script from "./PendingOrderModal.vue?vue&type=script&lang=js"
export * from "./PendingOrderModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__